/**
 Type of alpine data params

 showPopup: boolean;

 showStep: 'subscription' | 'thank-you'; 
 @usage (showStep): 
 * Type of step to show in popup
 * subscription: show subscription form
 * thank-you: show thank you message with register button
 
 email: string;
 errMsg: string;
 loading: boolean;
 multipleOptions: string[];

 * See function usage in function comment section
 setLocalStorageDelayDate: () => void;
 togglePopup: () => void;
 setStep: () => void;
 onChooseMultipleOption: (option: string) => void;
 submitEmailForm: () => void;
 */

document.addEventListener("alpine:init", () => {
  // Extract theme global variables from theme.liquid
  const { apiUrl, acceptedLanguage, apiKey, xAppid } = theme.emailSubscription;

  // Get popup data settings from popup element
  const popup = document.getElementById("dpu-popup");
  const {
    popupDelayDays,
    popupDelaySeconds,
    autoShowPopup,
  } = popup.dataset;

  Alpine.data("dpuPopup", () => ({
    showPopup: false,
    showStep: "subscription",
    email: "",
    errMsg: "",
    loading: false,
    multipleOptions: [],
    // Set delay date to local storage
    setLocalStorageDelayDate() {
      const targetDay = new Date();
      // Set to 0 to make sure the saved time is on the target day 12am
      targetDay.setHours(0);
      targetDay.setMinutes(0);
      targetDay.setSeconds(0);
      targetDay.setMilliseconds(0);

      // Today + delay days
      const delayDate = new Date().getDate() + this.popupDelayDate;
      targetDay.setDate(delayDate);
      // Save delay date to local storage and use it to check if popup should show
      localStorage.setItem(
        `${window.location.hostname}_dpu_popup_delay_date`,
        targetDay
      );
    },
    // Toggle popup
    togglePopup() {
      this.showPopup = !this.showPopup;
      if (!this.showPopup) {
        this.setLocalStorageDelayDate();

        this.email = "";
        this.errMsg = "";
      }
    },
    // Add or remove multiple option from multipleOptions array
    onChooseMultipleOption(option) {
      if (this.multipleOptions.includes(option)) {
        this.multipleOptions = this.multipleOptions.filter(
          (item) => item !== option
        );
      } else {
        this.multipleOptions.push(option);
      }
    },
    // Set step
    setStep(step) {
      this.showStep = step;
    },

    // Submit email form
    async submitEmailForm() {
      this.errMsg = "";

      // Validation
      const isEmailValid = validateEmail(this.email);
      if (this.multipleOptions.length === 0) {
        this.errMsg =
          "Please select at least one option.";
        return;
      }
      if (this.email === "") {
        this.errMsg = "Please enter your email address.";
        return;
      }
      if (!isEmailValid) {
        this.errMsg =
          "Please enter a valid email address (Example: name@domain.com)";
        return;
      }

      // Functions from subscription-form-common.js
      let fieldsArray = createFieldsArray(dpuPopupSettingJsons);
      const contactListId = getContactListId(
        dpuPopupSettingJsons
      );

      // Add extra fields to fieldsArray for multiple choice field
      const {
        m_id_mc,
        m_overwrite_mc,
      } = dpuPopupSettingJsons;

      fieldsArray = [...fieldsArray, {
        id: m_id_mc,
        type: "multiple",
        value: this.multipleOptions.map(Number),
        overwrite: m_overwrite_mc,
      }];

      const subscribeInfoCookie = window.getCookieForEmarsys('subscribe_info');
      let eventTracking = null;
      
      if (subscribeInfoCookie) {
        try {
          const decodedCookie = decodeURIComponent(subscribeInfoCookie)
          eventTracking = JSON.parse(decodedCookie);
          delete eventTracking.ts
          console.log('eventTracking', eventTracking);
        } catch (error) {
          console.log('eventTracking error', subscribeInfoCookie);
          console.warn('Failed to parse subscribe_info cookie:', error);
        }
      };

      const apiBody = {
        email: this.email,
        contactListId,
        fields: fieldsArray,
        ...(eventTracking && { eventTracking }),
      };

      try {
        this.loading = true;
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            // Header global settings are defined in pdp-subscription-form.liquid
            // Except traceId is defined in subscription-form-common.js
            "Content-Type": "application/json",
            apiKey: apiKey,
            traceId: traceId,
            "X-appid": xAppid,
            "Accepted-Language": acceptedLanguage,
          },
          body: JSON.stringify(apiBody),
        });

        const data = await response.json();

        if (data.message === "Success") {
          this.setStep("thank-you");
          this.setLocalStorageDelayDate();
        } else {
          this.errMsg =
            "Oops... Something went wrong, please refresh and try again.";
        }
      } catch (error) {
        this.errMsg =
          "Oops... Something went wrong, please refresh and try again.";
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    init() {
      // Set data attribute to alpine data
      this.popupDelayDate = Number(popupDelayDays);

      // If user has closed the popup before, check if the delay date is still valid
      const now = new Date();
      const delayDate = localStorage.getItem(
        `${window.location.hostname}_dpu_popup_delay_date`
      );

      const isDelayDateValid = now.getTime() < new Date(delayDate).getTime();
      // Undefine autoShowPopup will be false
      const parsedAutoShowPopup = autoShowPopup
        ? JSON.parse(autoShowPopup)
        : false;

      // If user is out of delay date range, show popup automatically after X seconds when enter the page
      // Otherwise, hide popup
      if (!isDelayDateValid && parsedAutoShowPopup) {
        setTimeout(() => {
          this.showPopup = true;
        }, Number(popupDelaySeconds) * 1000);
      }
    },
  }));
});
